import React from "react";

interface ProgressBarProps {
  progress: number;
}
export const ProgressBar: React.FC<ProgressBarProps> = React.memo(({ progress }) => (
  <div className="progress-bar-container">
    <div className="progress-bar" style={{ width: `${progress}%` }}></div>
  </div>
));
